<template>
  <div class="forfun-server-list-container">
    <h2 class="title-lined">
      <div class="title-line">servidores forfun pra aquecer</div>
    </h2>
    <span class="muted">atualizado a cada 35s</span>
    <div class="server-list">
      <a :href="`steam://connect/${server.server_ip}`" :class="`gs-widget ${server.map_name}`" v-for="server in servers" :key="server.id">
        <p class="hostname">{{server.server_name}}</p>
        <p class="map"><span class="icon is-small"><i class="fa fa-bullseye"></i></span> {{server.map_name}}</p>
        <p class="players"><span class="icon is-small"><i class="fa fa-users"></i></span> {{server.number_of_players}}/{{server.max_players}}</p>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForfunServerList',
  data () {
    return {
      servers: null,
      interval: null
    }
  },
  methods: {
    initialize() {
      this.$http
        .get('pug_servers.json')
        .then(response => (this.servers = response.data))
    }
  },
  mounted () {
    this.initialize()
    this.interval = setInterval(() => {
      this.initialize()
    }, 35000)
  },
  beforeDestroy () {
    clearInterval(this.interval)
  }
}
</script>

<style lang="sass" scoped>
.forfun-server-list-container
  margin-bottom: 20px
  
h2.title-lined
  margin-bottom: -7px
span.muted
  font-size: 11px
  color: #999

.server-list
  display: flex
  flex-wrap: wrap
  justify-content: space-between
  .gs-widget
    width: 49%
  
.gs-widget
  display: block
  background: #333333
  padding: 10px
  color: rgba(255, 255, 255, .5)
  filter: contrast(130%)
  transition: all .1s
  opacity: .5
  border-radius: 4px

  &:hover
    filter: contrast(160%)
    text-decoration: none
    opacity: 1

  span.icon
    font-size: 13px
  
  &:not(:last-child)
    margin-bottom: 6px
  
  p
    margin: 0 !important
    padding: 0 !important
    font-size: 11px
    &.hostname
      font-weight: bold
    &.map
    &.players
      font-weight: bold
      color: white
</style>
